import React, { FC, useState } from 'react';
import dayjs from 'dayjs';
import useIntervalEffect from '../../../hooks/use-interval-effect/use-interval-effect';

interface Props {
  readonly date: Date;
}

const Countdown: FC<Props> = ({ date }) => {
  const [expiryTime, setExpiryTime] = useState<string>('');

  useIntervalEffect(
    () => {
      const minutes = Math.max(0, dayjs(date).diff(new Date(), 'minute'));
      const seconds = Math.max(0, dayjs(date).diff(new Date(), 'second') % 60);

      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');

      setExpiryTime(`${formattedMinutes}:${formattedSeconds}`);
    },
    1000,
    [date]
  );

  return <>{expiryTime}</>;
};

export default Countdown;
